import { ActionType, createReducer } from 'typesafe-actions';
import { ILastWinnersState } from './types';
import { setLastWinners, addNewRoundToStatistics } from './actions';

export const defaultDiceStatistics: ILastWinnersState = {
  lastWinners: [],
};

const actions = {
  setLastWinners,
  addNewRoundToStatistics,
};

export const lastWinnersReducer = createReducer<ILastWinnersState, ActionType<typeof actions>>(
  defaultDiceStatistics,
)
  .handleAction(setLastWinners, (state, { payload }) => ({
    ...state,
    lastWinners: payload,
  }))
  .handleAction(addNewRoundToStatistics, (state, { payload }) => ({
    ...state,
    lastWinners: [
      ...(state.lastWinners.length === 50 ? state.lastWinners.slice(1) : state.lastWinners),
      payload,
    ],
  }));
